// routes
import { PATH_ADMIN } from '../../routes/paths';
// components
import Iconify from '../../components/Iconify';
// utils
import { addLanguageToPath } from '../../utils/languageUtils';
import { defaultLang } from '../../config';

// ----------------------------------------------------------------------

const ICONS = {
  dashboard: <Iconify icon="la:buffer" />,
  user: <Iconify icon="la:user" />,
  products: <Iconify icon="bi:cart2" />,
  orders: <Iconify icon="mdi:receipt-text-outline" />,
  mail: <Iconify icon="la:envelope" />,
  emailTest: <Iconify icon="mdi:email-send" />,
  social: <Iconify icon="mdi:calendar-month" />,
  telegram: <Iconify icon="mdi:telegram" />,
  key: <Iconify icon="mdi:key" />,
  image: <Iconify icon="la:image" />,
  ingredient: <Iconify icon="mdi:flask" />,
  jobs: <Iconify icon="la:briefcase" />,
  pro: <Iconify icon="mdi:crown" />,
  docs: <Iconify icon="mdi:book-open-page-variant" />,
};

export default function getAdminNavConfig(lang = defaultLang.value) {
  // Helper to add language prefix to all paths
  const localPath = (path) => addLanguageToPath(path, lang);

  return [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: 'nav.admin.subheader.general',
      items: [
        {
          title: 'nav.admin.dashboard',
          path: localPath(PATH_ADMIN.dashboard),
          icon: ICONS.dashboard,
        },
      ],
    },

    // MANAGEMENT
    // ----------------------------------------------------------------------
    {
      subheader: 'nav.admin.subheader.management',
      items: [
        {
          title: 'nav.admin.users',
          path: localPath(PATH_ADMIN.users.root),
          icon: ICONS.user,
          children: [
            { title: 'nav.admin.users_list', path: localPath(PATH_ADMIN.users.list) },
            { title: 'nav.admin.users_create', path: localPath(PATH_ADMIN.users.new) },
          ],
        },
        {
          title: 'nav.admin.pro_management',
          path: localPath(PATH_ADMIN.proManagement),
          icon: ICONS.pro,
        },
        {
          title: 'nav.admin.products',
          path: localPath(PATH_ADMIN.products),
          icon: ICONS.products,
        },
        {
          title: 'nav.admin.orders',
          path: localPath(PATH_ADMIN.orders),
          icon: ICONS.orders,
        },
      ],
    },

    // TOOLS
    // ----------------------------------------------------------------------
    {
      subheader: 'nav.admin.subheader.tools',
      items: [
        {
          title: 'nav.admin.brevo',
          path: localPath(PATH_ADMIN.brevo),
          icon: ICONS.mail,
        },
        {
          title: 'nav.admin.email_test',
          path: localPath(PATH_ADMIN.emailTest),
          icon: ICONS.emailTest,
        },
        {
          title: 'nav.admin.social',
          path: localPath(PATH_ADMIN.social),
          icon: ICONS.social,
        },
        {
          title: 'nav.admin.telegram.title',
          path: localPath(PATH_ADMIN.telegram),
          icon: ICONS.telegram,
        },
        {
          title: 'nav.admin.api_keys',
          path: localPath(PATH_ADMIN.apiKeys),
          icon: ICONS.key,
        },
        {
          title: 'nav.admin.image_approval',
          path: localPath(PATH_ADMIN.imageApproval),
          icon: ICONS.image,
        },
        {
          title: 'nav.admin.ingredient_approval',
          path: localPath(PATH_ADMIN.ingredientApproval),
          icon: ICONS.ingredient,
        },
        {
          title: 'nav.admin.jobs',
          path: localPath(PATH_ADMIN.jobs),
          icon: ICONS.jobs,
        },
      ],
    },

    // DOCUMENTATION
    // ----------------------------------------------------------------------
    {
      subheader: 'nav.admin.subheader.documentation',
      items: [
        {
          title: 'nav.admin.system_docs',
          path: localPath(PATH_ADMIN.systemDocs),
          icon: ICONS.docs,
        },
      ],
    },
  ];
}
